import {
  CREATE_REMINDER_INIT,
  CREATE_REMINDER_SUCCESS,
  CREATE_REMINDER_ERROR,
  CREATE_REMINDER_CLEAR,
} from '../../actions/reminder/constants';

const initState = {
  loading: false,
  data: null,
  error: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case CREATE_REMINDER_INIT:
      return { ...state, loading: true, error: null };
    case CREATE_REMINDER_SUCCESS:
      return { ...state, loading: false, error: null, data: action.payload };
    case CREATE_REMINDER_ERROR:
      return { ...state, loading: false, error: action.payload };
    case CREATE_REMINDER_CLEAR:
      return { ...state, loading: false, data: null, error: null };
    default:
      return state;
  }
};
